/* This file is generated by createIcons.js any changes will be lost. */
import createIcon from '../createIcon';
export const GoogleDriveIconConfig = {
  name: 'GoogleDriveIcon',
  height: 512,
  width: 512,
  svgPath: 'M339 314.9L175.4 32h161.2l163.6 282.9H339zm-137.5 23.6L120.9 480h310.5L512 338.5H201.5zM154.1 67.4L0 338.5 80.6 480 237 208.8 154.1 67.4z',
  yOffset: '',
  xOffset: '',
  transform: ''
};
export default createIcon(GoogleDriveIconConfig);